export default __webpack_public_path__ + "static/media/C2.5fa2aaf2.png";